import axios from "axios";

export const useExampleService = () => {
  const getListExample = async () => {
    const response = await axios.get(
      "https://jsonplaceholder.typicode.com/posts"
    );

    return response.data;
  };

  return {
    getListExample,
  };
};
